import '.g3{margin-bottom:1.875rem;}.ssr-plugin'
import '.k{display:grid;}.ssr-plugin'
import '.q{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'
import { styled } from 'inlines'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'
import { pages } from '@app/util/links'
import useMediaQuery from '@app/util/useMediaQuery'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { labelAddressBuilder } from '@app/util/helpers'
import { Empty } from '@app/components/blocks/empty/Empty'
import BuilderImage from '@app/assets/images/builder.png'

export const Initiatives = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const translations = useTranslations().app
  const isMobile = useMediaQuery()

  return (
    <Column>
      <div className="g3">
        <Title.H4 style={{ marginBottom: '0.625rem' }}>
          {translations.serviceProviderPage.ourInitiatives}
        </Title.H4>
        <Text.Medium>
          {translations.serviceProviderPage.ourInitiativesDescription}
        </Text.Medium>
      </div>

      {!serviceProvider?.initiatives ||
      serviceProvider.initiatives.length === 0 ? (
        <Empty
          title={translations.serviceProviderPage.noInitiativesTitle}
          imageSrc={BuilderImage}
          ctaLabel={translations.serviceProviderPage.noInitiativesCta}
          ctaLink={pages.dashboardStartInitiative}
        >
          {translations.serviceProviderPage.noInitiativesDescription}
        </Empty>
      ) : (
        <div className="k q"
          style={{
            gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',}}
        >
          {serviceProvider.initiatives &&
            serviceProvider.initiatives.map((initiative, index) => (
              <InitiativeCard
                key={initiative.slug}
                to={pages.initiative(initiative.slug)}
                tagText={
                  initiative.searchingForMembers
                    ? translations.common.initiativeStatus.searchingForMembers
                    : translations.common.initiativeStatus
                        .notSearchingForMembers
                }
                image={initiative.images[0]?.src ?? defaultProjectPicture}
                location={labelAddressBuilder(
                  initiative.location.address,
                  translations.common.notSpecified,
                )}
                phase={initiative.phase?.name}
                title={initiative.title}
                description={initiative.description}
                variant={index === 0 && !isMobile ? 'spotlight' : 'default'}
                style={
                  index === 0
                    ? { gridColumn: isMobile ? 'span 1' : 'span 2' }
                    : {}
                }
              />
            ))}
        </div>
      )}
    </Column>
  )
}
